import React, { useState } from 'react'
import './loginStyle.css'
import pass_icon from './Assets/password.png'
import email_icon from './Assets/email.png'
import { signInWithEmailAndPassword } from 'firebase/auth/web-extension'
import { auth } from '../firebase-config/firebase'
import { useNavigate } from 'react-router-dom'
import Swal from "sweetalert2";

const LoginSignIn = () => {
  
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try{
            await signInWithEmailAndPassword(auth, email, password)
            console.log("Usuario logeado correctamente");
            navigate('/home')
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Contraseña o correo incorrectos!",
                footer: '<a href="#">Intentalo de nuevo</a>'
              });
        }
    }

    return (

        <div className='Container w-adapt'>
            
                <div className='Header'>
                    <div className='Text'>Ingresar</div>
                    <div className='underlineL'></div>
                </div>
            <form onSubmit={handleSubmit}>
                <div className='inputs'>
                    
                    <div className='input w-adapt'>
                        <img src={email_icon} alt='' />
                        <input 
                        type="email" 
                        placeholder='Correo' 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}/>
                    </div>
                    <div className='input w-adapt'>
                        <img src={pass_icon} alt='' />
                        <input type="password"
                         placeholder='Contraseña'
                         value={password}
                        onChange={(e) => setPassword(e.target.value)} />
                    </div>
                </div>
                <div className='submit-container d-flex justify-content-center'>
                    <button type='submit' className="submit">Ingresar</button>
                </div>
            </form>           
        </div>
    )
}
export default LoginSignIn